import React, { createContext, useContext, useState, useCallback } from "react";
import AppSnackbar from "./snackbar";

// Create Context
const SnackbarContext = createContext();

// Provider Component
export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Function to show snackbar anywhere
  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}

      {/* Global Snackbar (always available) */}
      <AppSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleClose}
      />
    </SnackbarContext.Provider>
  );
};

// Hook to use Snackbar anywhere
export const useSnackbar = () => useContext(SnackbarContext);
